import { render, staticRenderFns } from "./NotificacionesRecientes.vue?vue&type=template&id=7a8371fc&scoped=true"
import script from "./NotificacionesRecientes.vue?vue&type=script&lang=ts"
export * from "./NotificacionesRecientes.vue?vue&type=script&lang=ts"
import style0 from "./NotificacionesRecientes.vue?vue&type=style&index=0&id=7a8371fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8371fc",
  null
  
)

export default component.exports